<script setup lang="ts">
const form = useForm({
	method: 'POST',
	url: route('register'),
	fields: {
		name: '',
		store_url: 'https://',
		email: '',
		password: '',
		password_confirmation: '',
	},
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/security.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<ui-card-content>
		<ui-form @submit.prevent="form.submit">
			<ui-form-item>
				<ui-label for="name">
					{{ t('validation.attributes.name') }}
				</ui-label>
				<ui-input
					id="name"
					v-model="form.fields.name"
					required
					autofocus
					autocomplete="name"
				/>
				<ui-form-error :message="form.errors.name" />
			</ui-form-item>

			<ui-form-item>
				<ui-label for="store_url">
					{{ t('validation.attributes.store_url') }}
				</ui-label>
				<ui-input
					id="store_url"
					v-model="form.fields.store_url"
					required
					type="url"
				/>
				<ui-form-error :message="form.errors.store_url" />
			</ui-form-item>

			<ui-form-item>
				<ui-label for="email">
					{{ t('validation.attributes.email') }}
				</ui-label>
				<ui-input
					id="email"
					v-model="form.fields.email"
					required
					autocapitalize="off"
					autocomplete="username"
					autocorrect="off"
					type="email"
				/>
				<ui-form-error :message="form.errors.email" />
			</ui-form-item>

			<ui-form-item>
				<ui-label for="password">
					{{ t('validation.attributes.password') }}
				</ui-label>
				<ui-input
					id="password"
					v-model="form.fields.password"
					required
					autocapitalize="off"
					autocomplete="new-password"
					autocorrect="off"
					type="password"
				/>
				<ui-form-error :message="form.errors.password" />
			</ui-form-item>

			<ui-form-item>
				<ui-label for="password_confirmation">
					{{ t('validation.attributes.password_confirmation') }}
				</ui-label>
				<ui-input
					id="password_confirmation"
					v-model="form.fields.password_confirmation"
					required
					autocapitalize="off"
					autocomplete="new-password"
					autocorrect="off"
					type="password"
				/>
				<ui-form-error :message="form.errors.password_confirmation" />
			</ui-form-item>

			<ui-button type="submit" :loading="form.processing">
				{{ t('app.buttons.register') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>
		</ui-form>
	</ui-card-content>

	<ui-card-footer :class="cn('rounded-b-none sm:rounded-b-xl', $attrs.class ?? '')">
		<div class="flex w-full items-center justify-center gap-1 text-sm text-gray-500">
			<span>{{ t('app.already_have_an_account') }}</span>
			<ui-link :href="route('login')">
				{{ t('app.buttons.sign_in') }}
			</ui-link>
		</div>
	</ui-card-footer>
</template>
